/*
 *  Copyright (C) 2017 Atelier Cartographique <contact@atelier-cartographique.be>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, version 3 of the License.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { IDataTable } from 'sdi/components/table';
import { TableState } from 'sdi/components/table2';
import {
    Attachment,
    Category,
    FeatureCollection,
    IBaselayerCategory,
    ILayerInfo,
    IMapBaseLayer,
    IMapInfo,
    Inspire,
    IUser,
    MapLink,
    MessageRecord,
    RemoteResource,
    StreamingRequestFilter,
    StreamingState,
} from 'sdi/source';

import { ButtonComponent } from 'sdi/components/button';
import {
    FeaturePath,
    IMapScale,
    IMapViewData,
    Interaction,
    PrintRequest,
    PrintResponse,
} from 'sdi/map';
import { IToolGeocoder } from 'sdi/ports/geocoder';
import { Collection, Nullable } from 'sdi/util';

import { PrintProps, PrintState } from '../components/print';

import {
    AppLayout,
    HarvestStep,
    HomeConfig,
    ILegend,
    IMenuData,
    IPositioner,
    IShare,
    IToolWebServices,
} from './types';

declare module 'sdi/shape/types' {
    export interface IShape {
        'app/layout': AppLayout;
        'app/current-map': string | null;
        'app/current-layer': string | null;
        'app/table/selected': boolean;
        'app/selected-features': FeaturePath[];
        'app/map-ready': boolean;
        'app/route': string[];

        'component/legend': ILegend;
        'component/menu': IMenuData;
        'component/table': TableState;
        'component/table/extract': IDataTable;
        'component/home': HomeConfig;
        'component/legend/expand-image': boolean;
        'component/legend/show-wms-legend': boolean;
        'component/legend/webservices': IToolWebServices;
        'component/legend/geocoder': IToolGeocoder;
        'component/legend/positioner': IPositioner;
        'component/legend/share': IShare;
        'component/button': ButtonComponent;
        'component/print': PrintState;
        'component/bookmark/current-index': Nullable<number>;

        'component/harvest': HarvestStep;

        'port/map/view': IMapViewData;
        'port/map/scale': IMapScale;
        'port/map/interaction': Interaction;
        'port/map/loading': MessageRecord[];
        'port/map/printRequest': PrintRequest<PrintProps | null>;
        'port/map/printResponse': PrintResponse<PrintProps | null>;

        'data/attachments': Attachment[];
        'data/baselayercategories': IBaselayerCategory[];
        'data/baselayers': IMapBaseLayer[];
        'data/categories': Category[];
        'data/datasetMetadata': Collection<Inspire>;
        'data/features/stream': StreamingState;
        'data/filters': Collection<StreamingRequestFilter[]>;
        'data/layerinfo-list': ILayerInfo[];
        'data/layers': Collection<FeatureCollection>;
        'data/links': Collection<MapLink[]>;
        'data/maps': RemoteResource<IMapInfo[]>;
        'data/roles': Category[];
        'data/users': IUser[];

        'remote/errors': Collection<string>;
    }
}
